import { buildLookupValues, buildLookupPayload } from './lookupFormValues';

export const splitAliases = value => String(value ?? '').split(/[;,]/).map(alias => alias.trim()).filter(Boolean);

export const removeAliasPayload = (fields, record, alias) => {
    const values = buildLookupValues(fields, record);
    const aliases = splitAliases(values.aliases);
    if (!aliases.includes(alias)) throw new Error('This alias is no longer present. Check the updated list.');
    return buildLookupPayload(fields, { ...values, aliases: aliases.filter(value => value !== alias).join(', ') });
};

export const appendAliasPayload = (fields, record, additions) => {
    const values = buildLookupValues(fields, record);
    const existing = splitAliases(values.aliases);
    const seen = new Set(existing.map(alias => alias.toLowerCase()));
    const next = additions.map(value => String(value ?? '').trim());
    if (!next.length || next.some(value => !value)) throw new Error('Enter an alias in each new row.');
    for (const alias of next) {
        if (/[;,]/.test(alias)) throw new Error('Enter one alias per row without commas or semicolons.');
        if (seen.has(alias.toLowerCase())) throw new Error(`The alias "${alias}" already exists. Enter a different alias.`);
        seen.add(alias.toLowerCase());
    }
    return buildLookupPayload(fields, { ...values, aliases: [...existing, ...next].join(', ') });
};
